/**
 * Portable base64url decode (works in browser, Node.js, and React Native)
 */
function base64UrlDecode(str) {
    // Convert base64url to base64
    let base64 = str.replace(/-/g, '+').replace(/_/g, '/');
    // Pad with '=' to make length a multiple of 4
    while (base64.length % 4 !== 0) {
        base64 += '=';
    }
    // Decode using Uint8Array (works everywhere)
    const bytes = Uint8Array.from(globalThis.atob(base64), (c) => c.charCodeAt(0));
    return new TextDecoder().decode(bytes);
}
/**
 * Decode JWT payload without verification (for client-side expiry checks)
 */
export function decodeTokenPayload(token) {
    try {
        const base64Url = token.split('.')[1];
        if (!base64Url)
            return null;
        return JSON.parse(base64UrlDecode(base64Url));
    }
    catch {
        return null;
    }
}
/**
 * Check if a token is expired (with 60s buffer)
 */
export function isTokenExpired(token) {
    const payload = decodeTokenPayload(token);
    if (!payload || typeof payload.exp !== 'number')
        return true;
    return payload.exp * 1000 < Date.now() + 60_000;
}
/**
 * Extract accountId from JWT token
 */
export function getAccountIdFromToken(token) {
    const payload = decodeTokenPayload(token);
    if (!payload || typeof payload.acc !== 'string')
        return null;
    return payload.acc;
}
/**
 * True when the token carries a restricted-session (`rs`) claim, whatever its value, or cannot
 * be decoded. Mirrors the backend's `isRestrictedSessionClaim` and fails closed the same way:
 * a client that cannot tell must behave as if the session is restricted.
 */
export function isRestrictedSessionToken(token) {
    const payload = decodeTokenPayload(token);
    if (!payload)
        return true;
    return payload.rs !== undefined && payload.rs !== null;
}
